import { cn } from "@/common/helpers/utils";
import { type ReactElement, type ReactNode } from "react";

export enum PlaceholderLogoSize {
  Sm = "sm",
  Md = "md",
  Lg = "lg",
}

const PLACEHOLDER_LOGO_SIZE_CLASSES: Record<PlaceholderLogoSize, string> = {
  [PlaceholderLogoSize.Sm]: "size-6 text-xs font-normal",
  [PlaceholderLogoSize.Md]: "size-10 text-xs font-normal",
  [PlaceholderLogoSize.Lg]: "size-12 text-lg font-semibold",
};

export interface PlaceholderLogoProps {
  label: string;
  size?: PlaceholderLogoSize;
  children?: ReactNode;
  className?: string;
}

export function PlaceholderLogo({
  label,
  size = PlaceholderLogoSize.Lg,
  children = "?",
  className,
}: PlaceholderLogoProps): ReactElement {
  return (
    <div
      role="img"
      aria-label={label}
      className={cn(
        "border-border bg-primary/5 text-primary/80 flex aspect-square items-center justify-center rounded-full border border-dashed",
        PLACEHOLDER_LOGO_SIZE_CLASSES[size],
        className,
      )}
    >
      <span aria-hidden="true">{children}</span>
    </div>
  );
}
